module.exports = __webpack_public_path__ + "assets/05f898846b1fec16f83520c56a8a816e.png";